import { useCallback, useMemo } from "react";

import { getURL } from "@/lib/aws-amplify/storage";
import type { S3Object } from "@/lib/gql/__generated__/graphql";

import { RoundedFullButton } from "@/components/ui/button/rounded-full-button";
import { Image } from "@/components/ui/image/image";

type Props = {
	item: S3Object | null;
	onRemoveImage: () => void;
	canRemoveImage: boolean;
};

export const PreviewItem = ({ item, onRemoveImage, canRemoveImage }: Props) => {
	const url = useMemo(() => (item ? getURL(item) : ""), [item]);

	const handleClick = useCallback(() => {
		onRemoveImage();
	}, [onRemoveImage]);

	return (
		Boolean(item) && (
			<div className="group relative w-full max-w-[300px]">
				{Boolean(canRemoveImage) && (
					<div role="button" className="absolute right-3 top-2 h-4 w-4" onClick={handleClick}>
						<RoundedFullButton />
					</div>
				)}
				<Image src={url} alt="" className="h-full w-full rounded border border-zinc-200" />
			</div>
		)
	);
};

PreviewItem.displayName = "PreviewItem";
